import Vue from 'vue';
import { isObject } from 'Utils/common';

export class BaseReactiveClass {
  constructor(data) {
    this.$setAll(data);
  }

  $set(name, value, model = this) {
    Vue.set(model, name, value);
  }

  $setAll(data, model = this) {
    if (!data || typeof data !== 'object') return;
    Object.entries(data)
      .forEach(([key, value]) => {
        // If value is object and model exist as object too
        if (isObject(value) && isObject(model[key])) {
          // If object has $setAll function, means it's nested reactive class.
          if (typeof model[key].$setAll === 'function') {
            // so use $setAll function to update data
            model[key].$setAll(value);
          } else {
            // otherwise, call recursive to not lost observe set by field params in object
            this.$setAll(value, model[key]);
          }
        } else {
          this.$set(key, value, model);
        }
      });
  }
}
